import {
  VStack,
  Text,
  Pressable,
} from "@whoosh/design-system/src/components/primitive";
import { Theme } from "@whoosh/design-system/src/theme/restyle/theme";

import { TabBarItem } from "../../../hooks/useGetTabBarItems";

export const TopNavBarItem = ({
  item: { selected, routeName, label, icon: Icon, routeHandler },
}: {
  item: TabBarItem;
}) => {
  const bg: keyof Theme["colors"] = selected
    ? "surface-secondary"
    : "grayscale-0";

  return (
    <Pressable
      style={{ borderRadius: 16 }}
      px={4}
      py={5}
      width="auto"
      alignItems="center"
      justifyContent="center"
      _hover={{
        backgroundColor: "grayscale-200",
      }}
      _pressed={{
        backgroundColor: "grayscale-500",
      }}
      backgroundColor={bg}
      height={48}
      onPress={() => {
        routeHandler();
      }}
      testID={`tab-bar-item-${routeName}`}
      accessibilityRole="tab"
      accessibilityLabel={label}
      accessibilityState={{ selected }}
    >
      <VStack
        alignItems="center"
        justifyContent="center"
        gap={1}
        flexDirection={{ base: "column", md: "row" }}
      >
        <Icon fill="none" />

        <Text
          maxFontSizeMultiplier={2}
          color="grayscale-1000"
          marginLeft={{ base: 0, md: 2 }}
          variant="mainTiny"
          mb={0}
        >
          {label}
        </Text>
      </VStack>
    </Pressable>
  );
};
